
define('app/board/views/draftViewModeView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueInstanceModel',
	'known/models/userModel'
], function($, _, Backbone, LeagueInstanceModel){
	var DraftViewModeView = Backbone.View.extend({
		el: $("#viewModeNav"),
		
		initialize: function(options) {
			this.leagueInst = options.leagueInst;
			this.user = options.userModel;
			
			_.bindAll(this, 'showBoard');
			_.bindAll(this, 'showPlayerRanks');
			_.bindAll(this, 'showCustomRanks');
			_.bindAll(this, 'showTeamRosters');
			_.bindAll(this, 'showSnakeBoard');
			_.bindAll(this, 'showStandardBoard');
			
			$(this.el).find("#draftBoardViewListItem").on('click', this.showBoard);
			$(this.el).find("#playerViewListItem").on('click', this.showPlayerRanks);
			$(this.el).find("#customRanksViewListItem").on('click', this.showCustomRanks);
			$(this.el).find("#teamRosterViewListItem").on('click', this.showTeamRosters);
			$(this.el).find("#snakeOrderViewListItem").on('click', this.showSnakeBoard);
			$(this.el).find("#standardOrderViewListItem").on('click', this.showStandardBoard);
		},
		
		render: function () {
			if(this.leagueInst.get('draftType') == 'CUSTOM'){
				$(this.el).find("#snakeOrderViewListItem").show();
				$(this.el).find("#standardOrderViewListItem").show();
			}
			
			if(this.user.get('userName').toUpperCase() === 'CLICKYUSER'){
				$(this.el).find("#customRanksViewListItem").show();
			}
			
			return this;
		},
		
		hideAll: function() {
			$("#playerRankView").hide();
			$("#draftBoardView").hide();
			$("#customRanksView").hide();
			$("#teamRosterView").hide();
			$("#customSnakeDraftBoardView").hide();
			$("#customStandardDraftBoardView").hide();
		},
		
		showBoard: function() {
			this.hideAll();
			$("#draftBoardView").show();
			$('#viewModeNav').find(".user-menu").first().dropdown('toggle');
		},
		
		showPlayerRanks: function() {
			this.hideAll();
			$("#playerRankView").show();
			$('#viewModeNav').find(".user-menu").first().dropdown('toggle');
		},
		
		showCustomRanks: function() {
			this.hideAll();
			$("#customRanksView").show();
			$('#viewModeNav').find(".user-menu").first().dropdown('toggle');
		},
		
		showTeamRosters: function () {
			this.hideAll();
			$("#teamRosterView").show();
			$('#viewModeNav').find(".user-menu").first().dropdown('toggle');
		},
		
		showSnakeBoard: function () {
			this.hideAll();
			$("#customSnakeDraftBoardView").show();
			$('#viewModeNav').find(".user-menu").first().dropdown('toggle');
		},
		
		showStandardBoard: function () {
			this.hideAll();
			$("#customStandardDraftBoardView").show();
			$('#viewModeNav').find(".user-menu").first().dropdown('toggle');
		}
	});
	
	return DraftViewModeView;  
});